// extracted by mini-css-extract-plugin
module.exports = {"number-variants-wrapper":"NumberVariants_number-variants-wrapper__BNJcb"};